import React from "react";
import { Form, Row, Col } from "react-bootstrap";

const ConfigTab = ({
    form,
    setForm,
    provider
}) => {

    if (!provider) {
        return null;
    }

    const updateField = (fieldName, value) => {

        setForm(prev => ({
            ...prev,
            config: {
                ...prev.config,
                [fieldName]: value
            }
        }));

    };

    return (

        <>

            {/* Nome da conexão */}

            <Row className="mb-4">

                <Col md={12}>

                    <Form.Group>

                        <Form.Label>

                            Nome da conexão

                        </Form.Label>

                        <Form.Control
                            placeholder="Ex.: Recepção Clínica"
                            value={form.name}
                            onChange={(e) =>
                                setForm(prev => ({
                                    ...prev,
                                    name: e.target.value
                                }))
                            }
                        />

                        <Form.Text className="text-muted">

                            Este nome será utilizado para identificar esta conexão.

                        </Form.Text>

                    </Form.Group>

                </Col>

            </Row>

            {/* Campos do Provider */}

            <Row>

                {

                    provider.fields?.map((field) => (

                        <Col
                            md={field.col || 12}
                            key={field.name}
                            className="mb-3"
                        >

                            <Form.Group>

                                <Form.Label>

                                    {field.label}

                                    {

                                        field.required && (

                                            <span className="text-danger">

                                                {" "}*

                                            </span>

                                        )

                                    }

                                </Form.Label>

                                {

                                    field.type === "select"

                                        ?

                                        <Form.Select
                                            value={
                                                form.config[field.name] || ""
                                            }
                                            onChange={(e) =>
                                                updateField(
                                                    field.name,
                                                    e.target.value
                                                )
                                            }
                                        >

                                            <option value="">

                                                Selecione...

                                            </option>

                                            {

                                                field.options?.map(option => (

                                                    <option
                                                        key={option.value}
                                                        value={option.value}
                                                    >

                                                        {option.label}

                                                    </option>

                                                ))

                                            }

                                        </Form.Select>

                                        :

                                        <Form.Control
                                            type={field.type || "text"}
                                            placeholder={
                                                field.placeholder || ""
                                            }
                                            value={
                                                form.config[field.name] || ""
                                            }
                                            onChange={(e) =>
                                                updateField(
                                                    field.name,
                                                    e.target.value
                                                )
                                            }
                                        />

                                }

                                {

                                    field.help && (

                                        <Form.Text className="text-muted">

                                            {field.help}

                                        </Form.Text>

                                    )

                                }

                            </Form.Group>

                        </Col>

                    ))

                }

            </Row>

        </>

    );

};

export default ConfigTab;